export default {
    type: 'full-bleed-hero-carousel',
    name: 'Full Bleed Hero Carousel',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleFullBleedHeroCarousel',
            loader: () => import('./ModuleFullBleedHeroCarousel')
        },
        form: {
            name: 'ModuleFullBleedHeroCarouselForm',
            loader: () => import('./ModuleFullBleedHeroCarouselForm')
        }
    }
};
